import { page as pageIndex, globals } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
import { saveInitialValues, clearHistory } from './undo'
import { showModal } from './modal'
import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const ADD_BILL_TO_STORE_START = 'ADD_BILL_TO_STORE_START'
export const BILL_SAVED = 'BILL_SAVED'
export const ADD_BILL_TO_STORE_FAILURE = 'ADD_BILL_TO_STORE_FAILURE'
export const RAW_BILL_DATA_ERROR = 'RAW_BILL_DATA_ERROR'
export const RETURN_INITIAL_RBD = 'RETURN_INITIAL_RBD'
export const CREATE_NEW_BILL_RECORD = 'CREATE_NEW_BILL_RECORD'
export const OPEN_BILL_RECORD = 'OPEN_BILL_RECORD'
export const ADD_NEW_HISTORY_ITEM = 'ADD_NEW_HISTORY_ITEM'
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}

export function addBillToStore (billData, trackData, id) {
  return (dispatch) => {
    dispatch({ type: ADD_BILL_TO_STORE_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(billData)
    }
    fetch(`${globals.apiUrl}/LegisRawData`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 409 || response.status === 400) {
        return response.text().then((text) => {
          dispatch({
            type: RAW_BILL_DATA_ERROR,
            errorMessage: text
          })
          dispatch(showModal('Error-raw-bill-data-message'))
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: BILL_SAVED,
          payload: {
            billData: json
          }
        })
        dispatch(clearHistory(pageIndex.rawBillData))
        dispatch(saveInitialValues(pageIndex.rawBillData, trackData))
        if (id) {
          dispatch(openRawBillRecord(id, trackData))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ADD_BILL_TO_STORE_FAILURE })
    })
  }
}

export function returnInitialState () {
  return {
    type: RETURN_INITIAL_RBD
  }
}

export function createNewBillRecord () {
  return (dispatch) => {
    dispatch({
      type: CREATE_NEW_BILL_RECORD,
      newRecord: {
        RawFileId: 0,
        State: null,
        BillType: null,
        Session: null,
        PrefileYear: null,
        BillNumber: null,
        Introdate: ' ',
        SponsorFirstName: null,
        Sponsor: null,
        Url: null,
        Summary: null,
        History: null
      }
    })
    dispatch(openRawBillRecord(0))
    dispatch(clearHistory(pageIndex.rawBillData))
    dispatch(saveInitialValues(pageIndex.rawBillData, initialState.formDataValue.RBD))
  }
}

export function openRawBillRecord (id, trackData) {
  return (dispatch) => {
    dispatch({
      type: OPEN_BILL_RECORD,
      id
    })
    dispatch(saveInitialValues(pageIndex.rawBillData, id === 0 ? initialState.formDataValue.RBD : trackData))
  }
}

const returnDateFormat = (date) => {
  return date && date !== ' ' ? moment(date).format('MMM / DD / YYYY') : ' '
}

export function addNewHistoryItem (id) {
  return {
    type: ADD_NEW_HISTORY_ITEM,
    id
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.rawBillData
    ? state : actionHandler(state, action),
  [BILL_SAVED] : (state, action) => {
    const { billData } = action.payload
    const queue = state.renderData.rawBillDataQueue.map(item => {
      if (item.RawFileId === 0) {
        return billData
      } else return item
    })
    return {
      ...state,
      renderData: {
        ...state.renderData,
        billRecordSaved: true,
        rawBillDataQueue: queue,
        rawBillRecord: billData,
        amountOfBills: queue
      },
      formDataValue: {
        RBD: {
          ...state.formDataValue.RBD,
          notes: {
            textValues: {
              ...state.formDataValue.RBD.notes.textValues,
              history: billData.History
            }
          }
        }
      }
    }
  },
  [RAW_BILL_DATA_ERROR] : (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        billRecordSaved: false,
        errorMessage: action.errorMessage
      }
    }
  },
  [RETURN_INITIAL_RBD] : () => {
    return {
      ...initialState
    }
  },
  [CREATE_NEW_BILL_RECORD] : (state, action) => {
    const queue = [...state.renderData.rawBillDataQueue, action.newRecord]
    return {
      ...state,
      renderData: {
        ...state.renderData,
        billRecordSaved: false,
        rawBillDataQueue: queue,
        amountOfBills: queue
      },
      formDataValue: {
        RBD: {
          ...state.formDataValue.RBD,
          history: {
            dateTime: {
              'date-0': ' '
            },
            textValues: {
              'chamber-0': '',
              'historyAction-0': ''
            }
          }
        }
      }
    }
  },
  [OPEN_BILL_RECORD] : (state, action) => {
    const { id } = action
    const record = state.renderData.rawBillDataQueue.find(item => item.RawFileId === id)
    const recordIndex = state.renderData.rawBillDataQueue.findIndex(item => item.RawFileId === id) + 1
    return {
      ...state,
      renderData: {
        ...state.renderData,
        rawBillRecord: record
      },
      formDataValue: {
        RBD: {
          ...state.formDataValue.RBD,
          navigation: {
            textValues: {
              currentRecord: recordIndex
            }
          },
          baseData: {
            radio: {
              state: record.State,
              billType: record.BillType,
              session: record.Session,
              prefileYear: record.PrefileYear
            },
            textValues: {
              billNumber: record.BillNumber || '',
              firstName: record.SponsorFirstName || '',
              lastName: record.Sponsor || '',
              url: record.Url || ''
            },
            dateTime: {
              introDate: returnDateFormat(record.Introdate)
            }
          },
          notes: {
            textValues: {
              summary: record.Summary || '',
              history: record.History || ''
            }
          }
        }
      }
    }
  },
  [ADD_NEW_HISTORY_ITEM] : (state, action) => {
    return {
      ...state,
      formDataValue: {
        RBD: {
          ...state.formDataValue.RBD,
          history: {
            textValues: {
              ...state.formDataValue.RBD.history.textValues,
              [`chamber-${action.id}`]: '',
              [`historyAction-${action.id}`]: ''
            },
            dateTime: {
              ...state.formDataValue.RBD.history.dateTime,
              [`date-${action.id}`]: ' '
            }
          }
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {
    errorMessage: '',
    billRecordSaved: false,
    rawBillDataQueue: [{
      RawFileId: 0,
      State: null,
      BillType: null,
      Session: null,
      PrefileYear: null,
      BillNumber: null,
      Introdate: ' ',
      SponsorFirstName: null,
      Sponsor: null,
      Url: null,
      Summary: null,
      History: null,
      disableEditing: false
    }],
    rawBillRecord: {
      RawFileId: 0
    }
  },
  formDataValue: {
    RBD: {
      navigation: {
        textValues: {
          currentRecord: '1'
        }
      },
      baseData: {
        radio: {
          state: '',
          billType: '',
          session: '',
          prefileYear: ''
        },
        textValues: {
          billNumber: '',
          firstName: '',
          lastName: '',
          url: ''
        },
        dateTime: {
          introDate: ' '
        }
      },
      notes: {
        textValues: {
          summary: '',
          history: ''
        }
      },
      history: {
        dateTime: {
          'date-0': ' '
        },
        textValues: {
          'chamber-0': '',
          'historyAction-0': ''
        }
      }
    }
  }
}
export default function rawBillDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/rawBillDataEntry.js